import { useRouter } from "@/i18n/routing";

import Button from "@/components/ui/Button";

import { PATHS } from "@/consts";
import { Vouchers } from "@/features/checkout/Vouchers";
import { useTranslations } from "@/i18n/client";
import { useCart } from "@/lib/centra/hooks";
import { PaymentResult } from "@frend-digital/centra-types/orders";
import clsx from "clsx";
import { useCartModal } from "../CartModal/CartModal";
import styles from "./cart-summary.module.css";
import { useSelection } from "@frend-digital/centra/client";

export const CheckoutCartSummary = ({
  totals,
}: {
  totals: NonNullable<PaymentResult["order"]>["totals"];
}) => {
  const t = useTranslations();

  return (
    <div className={styles.summary}>
      <div className={styles.subtotals}>
        <div className={styles.subtotalShipping}>
          <span>
            <p>{t("checkout.summary.subtotal")}</p>
            <p>{totals?.itemsTotalPrice ?? "0,-"}</p>
          </span>

          <span>
            <p>{t("checkout.summary.shipping")}</p>
            <p>
              {!totals?.shippingPriceAsNumber
                ? t("checkout.summary.free")
                : (totals?.shippingPrice ?? "0,-")}
            </p>
          </span>
        </div>

        <span>
            <p>{t("checkout.summary.total")}</p>
            <p>{totals?.grandTotalPrice ?? "0,-"}</p>
          </span>

      </div>
    </div>
  );
};

const CartSummary = ({ isFinalized }: { isFinalized?: boolean }) => {
  const { data: cart, isPending, isLoading } = useCart();
  const { data: selection } = useSelection();
  const currency = selection?.selection?.currency;
  const modal = useCartModal();
  const router = useRouter();
  const t = useTranslations();

  const goToCheckout = () => {
    if (modal) modal?.closeModal();

    router.push(PATHS.checkout.index);
  };
  const emptyCart = !cart?.items?.length;

  return (
    <div
      className={clsx(
        styles.summary,
        modal && styles.summaryModal,
        (isPending || isLoading) && styles.loading,
      )}
    >
      <div className={styles.subtotals}>
        <div className={styles.subtotalShipping}>
          <span>
            <p>{t("checkout.summary.subtotal")}</p>
            <p>{cart?.itemsTotalPrice ?? "0,-"}</p>
          </span>

          <span>
            <p>{t("checkout.summary.shipping")}</p>
            <p>
              {!cart?.shippingPriceAsNumber
                ? t("checkout.summary.free")
                : (cart?.shippingPrice ?? "0,-")}
            </p>
          </span>
          {cart?.vouchers && cart.vouchers.length > 0 && currency &&
            <span>
              <p>{t("checkout.summary.discount")}</p>
              <p>{cart?.vouchers?.reduce((acc, curr) => acc + (curr.priceOffAsNumber || 0), 0)} {currency}</p>
            </span>
          }
        </div>

        {
          <span>
            <p>{t("checkout.summary.total")}</p>
            <p>{cart?.total ?? "0,-"}</p>
          </span>
        }

        {!isFinalized && !modal.isOpen && (
          <span className={styles.voucher}>
            <Vouchers />
          </span>
        )}
      </div>

      {!isFinalized && modal.isOpen && (
        <div className={styles.cart__actions}>
          <div>
            <Button disabled={emptyCart} onClick={goToCheckout} full>
              <span className="uppercase">{t("checkout.summary.button")}</span>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartSummary;
